import "./index.scss";
import SellTestimonial from "assets/images/sell-banners/sell-testimonial.jpg";

export const TestimonialsHighlight = () => (
  <div className="testimonials-highlight">
    <div className="container">
      <img src={SellTestimonial} alt="testimonial" />
      <div className="highlight-text">
        <p>
          "Great way to earn some extra cash selling off unneeded gift cards.
          Raise is my #1 pick."
        </p>
        <p className="signature">Andy D.</p>
      </div>
    </div>
  </div>
);
